// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function EggIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M23.332 7.445C21.06 4.036 18.317 2 16 2c-2.318 0-5.059 2.036-7.332 5.445C6.338 10.943 5 15.154 5 19a11 11 0 1 0 22 0c0-3.846-1.337-8.057-3.668-11.555ZM16 28a9.01 9.01 0 0 1-9-9c0-3.461 1.215-7.269 3.332-10.445C12.15 5.83 14.427 4 16 4c1.574 0 3.851 1.83 5.668 4.555C23.785 11.731 25 15.539 25 19a9.01 9.01 0 0 1-9 9Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
